<template>
    <div>  
        <h4 class="p-2">Matrícula</h4>
        <vs-row class="mt-4">
            <vs-col sm="12" lg="4">
                <form autocomplete="off">
                    <label for="institucion" class="labelInput">
                        Institución
                    </label>
                    <vs-select class="aqui pt-0" id="institucion" placeholder="Seleccionar Institución" :key="institucionId" v-model="institucion" :disabled="!instituciones.length" autocomplete="off" >
                        <template #message-danger v-if="errorFields.includes('institucion')">
                            Requerido
                        </template>
                        <template v-if="instituciones.length" autocomplete="off">
                            <vs-option v-for="option in instituciones" :key="option.id"  :label="option.text" :value="option.id">
                                {{option.text}}
                            </vs-option>
                        </template>
                        <template v-else>
                            <vs-option label="No hay datos" v-text="'No hay datos'" :value="0">
                            </vs-option>
                        </template>
                    </vs-select>
                </form>
            </vs-col>
            <vs-col sm="12" lg="4">
                <form autocomplete="off">
                    <label for="cicloEscolar" class="labelInput">
                        Ciclo Escolar
                    </label>
                    <vs-select :loading="loadingCiclo" class="aqui pt-0" id="cicloEscolar" placeholder="Seleccionar Ciclo Escolar" :key="cicloEscolarId" v-model="cicloEscolar" :disabled="!cicloEscolares.length" autocomplete="off" >
                        <template #message-danger v-if="errorFields.includes('institucion')">
                            Requerido
                        </template>
                        <template v-if="cicloEscolares.length" autocomplete="off">
                            <vs-option v-for="option in cicloEscolares" :key="option.id"  :label="option.text" :value="option.id">
                                {{option.text}}
                            </vs-option>
                        </template>
                        <template v-else>
                            <vs-option label="No hay datos" v-text="'No hay datos'" :value="0">
                            </vs-option>
                        </template>
                    </vs-select>
                </form>
            </vs-col>
            <vs-col sm="12" lg="4">
                <form autocomplete="off">
                    <label for="programa" class="labelInput">
                        Programa
                    </label>
                    <vs-select :loading="loadingPrograma" class="aqui pt-0" id="programa" placeholder="Seleccionar Programa" :key="programaId" v-model="programa" :disabled="!programas.length" autocomplete="off" >
                        <template v-if="programas.length" autocomplete="off">
                            <vs-option v-for="option in programas" :key="option.id"  :label="option.text" :value="option.id">
                                {{option.text}}
                            </vs-option>
                        </template>
                        <template v-else>
                            <vs-option label="No hay datos" v-text="'No hay datos'" :value="0">
                            </vs-option>
                        </template>
                    </vs-select>
                </form>
            </vs-col>
            <vs-col sm="12" lg="4">
                <form autocomplete="off">
                    <label for="grupo" class="labelInput">
                        Grupo
                    </label>
                    <vs-select :loading="loadingGrupo" class="aqui pt-0" id="grupo" placeholder="Seleccionar Grupo" :key="grupoId" v-model="grupo" :disabled="!grupos.length" autocomplete="off" >
                        <template v-if="grupos.length" autocomplete="off">
                            <vs-option v-for="option in grupos" :key="option.id"  :label="option.text" :value="option.id">
                                {{option.text}}
                            </vs-option>
                        </template>
                        <template v-else>
                            <vs-option label="No hay datos" v-text="'No hay datos'" :value="0">
                            </vs-option>
                        </template>
                    </vs-select>
                </form>
            </vs-col>
        </vs-row>
        <vs-row>
            <vs-col sm="12" lg="3" class="ml-auto">
                <vs-button
                    class="ml-auto"
                    @click="getMatriculas()"
                >
                    <i class="fas fa-search mr-2"></i>Buscar
                </vs-button>
            </vs-col>
        </vs-row>
        <tabla-matricula :users="users" :token="csrf_token" @refreshTable="getMatriculas"></tabla-matricula>
    </div>
</template>

<script>
import servicios from '../../../../api/requests/servicios'
import TablaMatricula from './tabla-matricula.vue'
export default {
    props: [
        'csrf_token'
    ],
    data(){
        return{
            institucion: '',
            instituciones: [],
            institucionId: (new Date()).getTime(),
            cicloEscolar: '',
            cicloEscolares: [],
            cicloEscolarId: (new Date()).getTime(),
            loadingCiclo: false,
            programa: '',
            programas: [],
            programaId: (new Date()).getTime(),
            loadingPrograma: false,
            periodo: '',
            periodos: [],
            periodoId: (new Date()).getTime(),
            loadingPeriodo: false,
            grupo: '',
            grupos: [],
            grupoId: (new Date()).getTime(),
            loadingGrupo: false,
            page: 1,
            errorFields: [],
            users: []
        }
    },
    components:{
        TablaMatricula
    },
    created(){
        this.getInstitucion()
    },
    methods:{
        async getInstitucion(){
            try {
                const response = await servicios.getInstitucion()
                this.instituciones = response.data
                this.institucionId =  (new Date()).getTime()
            }
            catch{
                
            }
        },
        async getCiclosEscolares(){
            this.loadingCiclo = true
            try {
                const response = await servicios.getCiclosEscolares(this.institucion)
                this.cicloEscolares = response.data
                this.cicloEscolarId =  (new Date()).getTime()
                this.loadingCiclo = false
            }
            catch{
                this.loadingCiclo = false
            }
        },
        async getPrograma(){
            this.loadingPrograma = true
            try {
                const response = await servicios.getPrograma(this.institucion)
                this.programas = response.data
                this.programaId =  (new Date()).getTime()
                this.loadingPrograma = false
            }
            catch{
                this.loadingPrograma = false
            }
        },
        async getPeriodo(){
            this.loadingPeriodo = true
            try {
                const response = await servicios.getPeriodo(this.programa)
                this.periodos = response.data
                this.periodoId =  (new Date()).getTime()
                this.loadingPeriodo = false
            }
            catch{
                this.loadingPeriodo = false
            }
        },
        async getGrupo(){
            if(this.cicloEscolar != ''){
                this.loadingGrupo = true
                try {
                    const params = {
                        ciclo_escolar_id: this.cicloEscolar
                    }
                    const response = await servicios.getGrupo(this.institucion, params)
                    this.grupos = response.data
                    this.grupoId =  (new Date()).getTime()
                    this.loadingGrupo = false
                }
                catch{
                    this.loadingGrupo = false
                }
            }
        },
        sanityForm () {
            this.errorFields = []
            if (!this.institucion) {
                this.errorFields.push('institucion')
            }
            if (!this.cicloEscolar) {
                this.errorFields.push('cicloEscolar')
            }
            if (!this.errorFields.length){
                const params = {
                    institucion_id: this.institucion,
                    ciclo_escolar_id: this.cicloEscolar,
                    page: this. page,
                }

                if(this.grupo != ''){
                    params.grupo_id = this.grupo
                }

                if(this.programa != ''){
                    params.programa_id = this.programa
                }

                if(this.periodo != ''){
                    params.atributo_id = this.periodo
                }

                return params
            } else {
                return null
            }
        },
        async getMatriculas(){
            const params = this.sanityForm()
            if(params){
                const loading = this.$vs.loading()
                try {
                    const { data: response } = await servicios.getMatriculas(params)
                    const { data: dataTable = [], per_page = 20, total = 0 } = response || {}
                    this.pages = Math.ceil(total/per_page) || 0
                    this.users = dataTable
                    loading.close()
                }
                catch(error){
                    loading.close()
                    console.log(error)
                }
            }
        },
    },
    watch:{
        institucion(){
            this.getCiclosEscolares()
            this.getPrograma()
            this.getPeriodo()
            this.getGrupo()
        },
        programa(){
            this.getPeriodo()
        },
        cicloEscolar(){
            this.getGrupo()
        }
    }
}
</script>